const  router = [
	{
		path: "/setting/layout",
		component: () => import('../../../pages/setting/Layout.vue'),
		meta: {title: '设置'},
		name: 'settingIndex',
		children:[
			{
				path: "/sysmenu",
				component: () => import('../../../pages/setting/Sysmenu.vue'),
				meta: {title: '菜单管理', type:'c', permission: 'setting_sysmenu'},
				name: 'settingIndex', // 选中的效果
			},
			{
				path: "/sysrole",
				component: () => import('../../../pages/setting/Sysrole.vue'),
				meta: {title: '角色管理', type:'c', permission: 'setting_sysrole'},
				name: 'setting_sysrole',
			},
			{
				path: "/setting/shop",
				component: () => import('../../../pages/setting/Index.vue'),
				meta: {title: '店铺资料', type:'c', permission: 'setting_shop'},
				name: 'setting_shop',
			},
			{
				path: "/mendian",
				component: () => import('../../../pages/setting/Mendian.vue'),
				meta: {title: '门店管理', type:'c', permission: 'setting_mendian'},
				name: 'setting_mendian',
			},
			{
				path: "/account",
				component: () => import('../../../pages/setting/Account.vue'),
				meta: {title: '帐号管理', type:'c', permission: 'setting_account'},
				name: 'setting_account',
			},
			{
				path: "/setting/sms",
				component: () => import('../../../pages/setting/Sms.vue'),
				meta: {title: '短信设置', type:'c', permission: 'setting_sms'},
				name: 'setting_sms',
			},
			{
				path: "/setting/integral",
				component: () => import('../../../pages/setting/Integral.vue'),
				meta: {title: '积分设置', type:'c', permission: 'setting_integral'},
				name: 'setting_integral',
			},
			{
				path: "/setting/balance",
				component: () => import('../../../pages/setting/Balance.vue'),
				meta: {title: '余额设置', type:'c', permission: 'setting_balance'},
				name: 'setting_balance',
			},
			{
				path: "/setting/buy",
				component: () => import('../../../pages/setting/Buy.vue'),
				meta: {title: '买单设置', type:'c', permission: 'setting_buy'},
				name: 'setting_buy',
			},
			{
				path: "/setting/printer",
				component: () => import('../../../pages/setting/Printer.vue'),
				meta: {title: '打印机设置', type:'c', permission: 'setting_printer'},
				name: 'setting_printer',
			},
		],
	}
];

export default router